import { Component, OnInit, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
@Injectable()
export class ContactComponent implements OnInit {

  submitting = false;
  sent = false;
  error = false;
  errorMessage = null;
  readonly emailRegex = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/);

  constructor(private http: HttpClient) {
    this.http = http;
  }

  ngOnInit() {
  }

  isSubmitting = () => {
    return this.submitting === true;
  }
  hasSubmitted = () => {
    return this.sent === true;
  }
  hasError = () => {
    return this.error === true;
  }

  submit = (name, email, message) => {
    if (this.submitting || this.sent || this.error) {
      return;
    }

    if (name.trim().length === 0 || email.trim().length === 0 || message.trim().length === 0) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }
    if (!this.emailRegex.test(email)) {
      this.errorMessage = 'Please enter a valid email address';
      return;
    }
    this.errorMessage = null;

    const t = this;
    t.submitting = true;

    const requestBody = {
      name,
      email,
      message
    };

    this.http.post(
      'https://api.get-dash.com/v1/contactform',
      requestBody
    ).subscribe((data) => {
      console.log(data);
      t.submitting = false;
      t.sent = true;
    },
    (error) => {
      t.submitting = false;
      t.error = true;
    }
    );

  }

}
